import mapKnownValues from "../../../utils/mapKnownValues";
import { MailingDetailsWithItemQuantity } from "../mailingDetailsWithItemQuantity";

export default class MarketingMaterialPosters {
  posterType = "";
  mailingDetails: MailingDetailsWithItemQuantity[] = [];

  constructor(params: Partial<MarketingMaterialPosters>) {
    mapKnownValues(this, params);
  }
}
